import { type Registry as Services, service } from '@ember/service';
import MarketSettingsUsersRoute from 'lumen/routes/market/settings/users';

export default class DestinationSettingsUsersRoute extends MarketSettingsUsersRoute {
  @service declare router: Services['router'];

  // redirectToTab passes the current hotel or market as the route model,
  // and neither is set inside a destination.
  beforeModel(): void {
    if (!this.settingsUsers.canOpenMultiHotelUsersTab) {
      this.router.transitionTo('destination.settings.index');
    }
  }
}
